<template>
  <div class="header">
     <b-container fluid>
      <div class="header-body">
        <slot></slot>
      </div>
     </b-container>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'success',
        description: 'Header background type'
      }
    }
  }
</script>
<style>
.header{
  background: transparent linear-gradient(180deg, #7584E6 0%, #5965B1 100%) 0% 0% no-repeat padding-box;
}
.header h1{
  color: #fff;
}
</style>
